import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer
        className={
          "footer" +
          (this.props.transparent !== undefined ? " footer-transparent" : "")
        }
      >
        <div
          className={
            "container" + (this.props.fluid !== undefined ? "-fluid" : "")
          }
        >
          <nav className="pull-left">
            <p className="copyright pull-left"> 
            <a href="http://soporte-rsviajes.softwareland.mx/" target="_blank">Manual de uso RSViajes</a>            
            </p> 
          </nav>
          <p className="copyright pull-right"> 
            &copy; {1900 + new Date().getYear()}{" "} 
            <span>RS Viajes</span> {" "} 
            Aviso de Privacidad 
          </p> 
        </div>
      </footer>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx